import { Cell, CoreCellProps } from "./cell";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../Tooltip";
import { useRef } from "react";
import styles from "./cell.module.scss";
import classNames from "classnames";

export interface TextCellProps extends CoreCellProps {
  value: string | null | undefined;
}

export const CellText = ({
  value,
  truncatePosition = "end",
  showTooltip = true,
  ...rest
}: TextCellProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const actualTextRef = useRef<HTMLDivElement>(null);

  const isTextOverflown =
    containerRef.current && textRef.current && actualTextRef.current
      ? textRef.current.clientWidth > containerRef.current.clientWidth ||
        (rest.enableTextWrapping &&
          textRef.current.clientHeight > actualTextRef.current.clientHeight)
      : false;

  const classes = classNames(styles.cellContent, {
    [styles.noWrap]: !rest.enableTextWrapping,
    [styles.cellContentMultipleLines]: rest.enableTextWrapping,
  });

  return (
    <>
      <Cell alignment="left" {...rest}>
        {value && (
          <div ref={containerRef} className={styles.cellContent}>
            {/*
              This text does not get displayed!
              This element will determine if the text width is greater than the container width.
              Which will ultimately display a tooltip if so. 
            */}
            <div
              ref={textRef}
              className={`${classes} ${styles.tooltipTriggerText}`}
              aria-hidden
            >
              {value}
            </div>

            {!isTextOverflown || !showTooltip ? (
              <div
                className={classes}
                style={{
                  WebkitLineClamp: rest.maxLines,
                }}
                ref={actualTextRef}
              >
                {value}
              </div>
            ) : (
              <Tooltip>
                <TooltipTrigger asChild>
                  <div
                    className={classes}
                    style={{
                      WebkitLineClamp: rest.maxLines,
                    }}
                    ref={actualTextRef}
                  >
                    {value}
                  </div>
                </TooltipTrigger>

                <TooltipContent variant="small" align="center" side="right">
                  {value}
                </TooltipContent>
              </Tooltip>
            )}
          </div>
        )}
      </Cell>
    </>
  );
};
